<app-inner-box>
  <app-subpage-header title="Produktionsaufträge"></app-subpage-header>
  <app-production-orders-list #listComponent></app-production-orders-list>
</app-inner-box>
